import { createContext, useReducer, useState, useContext } from 'react'

export const FlightContext = createContext() 

export const flightReducer = (state, action) => {
    switch (action.type) {
        case 'SET_FLIGHT':
            return { flights: action.payload }
        case 'CREATE_FLIGHT':
            return { flights: [action.payload, ...state.flights] }
        case 'UPDATE_FLIGHT':
            return { flights: action.payload }
        case 'DELETE_FLIGHT':
            return { flights: state.flights.filter(u => u._id !== action.payload._id) }
        default:
            return state
    }
}

export const FlightContextProvider = ({children}) => {
    const [state, dispatch] = useReducer(flightReducer, { flights: [] })
    const [targetFlight, setTargetFlight] = useState(null)
    return (<FlightContext.Provider value={{ ...state, dispatch, targetFlight, setTargetFlight}}>{ children }</FlightContext.Provider>)
}

export const useFlightContext = () => {
    const context = useContext(FlightContext)
    if(!context) throw Error('useFlightContext must be used inside an FlightContextProvider')
    return context
}